import { BaseElementWidget, SPI, TableEditorMode, ActiveRecordsOperator, ViewType, Widget } from '@kunlun/dependencies';
import { DefaultTableWidget } from '../table/DefaultTableWidget';
import MixinComponent from './MixinComponent.vue';
import { useAddItemSku } from '@/custom-widget/MindMap/hooks';
import { nextTick } from 'vue';

const { itemSkuHeaderList } = useAddItemSku();

@SPI.ClassFactory(
  BaseElementWidget.Token({
    widget: 'AddSkuTableWidget'
  })
)
export class AddSkuTableWidget extends DefaultTableWidget {
  initialize(props: any) {
    this.setMixinComponent(MixinComponent);
    super.initialize(props);
    return this;
  }

  @Widget.Reactive()
  protected get defaultPageSize(): number {
    return 100;
  }

  @Widget.Reactive()
  @Widget.Provide()
  protected get editorMode(): TableEditorMode {
    return TableEditorMode.table;
  }

  @Widget.Reactive()
  protected get isDetailView() {
    return this.getUrlParameters().viewType === ViewType.Detail;
  }

  @Widget.Method()
  protected onAddRow() {
    const record =
    {
      attrs: itemSkuHeaderList.value.map((v) => ({
        attrName: v || '',
        attrValue: '',
        showDelIcon: true
      }))
    };

    const nextDataSource = ActiveRecordsOperator.operator(this.dataSource, undefined)
      .push(record)
      .get();

    // 全表编辑的表格，新增或删除数据行时，需要先清空再赋值，否则页面现有的编辑态数据无法更新
    this.reloadDataSource([]);
    this.flushDataSource()
    nextTick(() => {
      this.reloadDataSource(nextDataSource);
      this.flushDataSource()
    });
  }

  protected beforeUnmount(): void {
    super.beforeUnmount();
    itemSkuHeaderList.value = [];
  }
}
